import { ElementQueries } from 'css-element-queries';

(() => {
    ElementQueries.listen();
    ElementQueries.init();
})();
